import React from "react";
import { DownloadOutlined, GoogleOutlined } from "@ant-design/icons";
import { Modal } from "../../../design-system";
import "./FinanceExportModal.scss";

/**
 * Reusable Finance Export Modal Component (Design System)
 * Used across Sales Orders, Purchase Orders, and other finance modules
 * Provides consistent export modal with local/google drive options
 * Refactored to use design-system Modal components
 */
const FinanceExportModal = ({
    visible,
    onCancel,
    onExport,
    title = "Export",
    description = "Where do you want the file to be saved?"
}) => {
    const handleLocalExport = () => {
        onExport('local');
    };

    const handleGoogleExport = () => {
        onExport('google');
    };

    const footerButtons = [
        {
            key: 'local',
            label: 'Local',
            variant: 'secondary',
            icon: <DownloadOutlined />,
            onClick: handleLocalExport
        },
        {
            key: 'google',
            label: 'Google',
            variant: 'secondary',
            icon: <GoogleOutlined />,
            onClick: handleGoogleExport
        }
    ];

    return (
        <Modal
            visible={visible}
            onClose={onCancel}
            width="small"
            className="finance-export-modal"
        >
            <Modal.Header title={title} />

            <Modal.Body padding="default">
                <div className="finance-export-modal__content">
                    <p className="finance-export-modal__description">
                        {description}
                    </p>
                </div>
            </Modal.Body>

            <Modal.Footer buttons={footerButtons} showDefaultClose={false} />
        </Modal>
    );
};

export default FinanceExportModal;
